export const loaders = [
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    }
]
